import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import RadioQuestion from './RadioQuestion';

export default function Step4Heating({ data, onUpdate, errors }) {
  const { t } = useTranslation();
  const hasEv = data.electric_vehicle === 'Ja' || data.electric_vehicle === 'Binnen 2 jaar waarschijnlijk';

  return (
    <div data-testid="quiz-step-4">
      <h2 className="text-2xl font-medium text-primary mb-6" style={{ fontFamily: 'Outfit' }}>{t('quiz.step4Title')}</h2>
      <div className="space-y-6">
        <RadioQuestion label={`${t('quiz.heatingType')} *`} value={data.heating_type} options={[{ value: 'Gas boiler (new)', label: t('quiz.heating.gasNew') }, { value: 'Gas boiler (old)', label: t('quiz.heating.gasOld') }, { value: 'Oil', label: t('quiz.heating.oil') }, { value: 'District heating', label: t('quiz.heating.district') }, { value: 'Heat pump', label: t('quiz.heating.heatPump') }, { value: 'Electric', label: t('quiz.heating.electric') }]} onChange={(val) => onUpdate({ heating_type: val })} testIdPrefix="heating" error={errors?.heating_type} />

        <div className="flex items-center space-x-2 p-3 border rounded-md" data-testid="floor-heating-checkbox">
          <Checkbox id="floor-heating" checked={data.floor_heating} onCheckedChange={(checked) => onUpdate({ floor_heating: checked })} />
          <Label htmlFor="floor-heating" className="cursor-pointer">{t('quiz.floorHeating')}</Label>
        </div>

        <RadioQuestion label={`${t('quiz.ventilationType')} *`} value={data.ventilation_type} options={[{ value: 'Natural (windows)', label: t('quiz.ventilation.natural') }, { value: 'Mechanical extract', label: t('quiz.ventilation.mechanical') }, { value: 'Balanced (heat recovery)', label: t('quiz.ventilation.balanced') }, { value: 'None', label: t('quiz.insulation.none') }]} onChange={(val) => onUpdate({ ventilation_type: val })} testIdPrefix="ventilation" error={errors?.ventilation_type} />

        <RadioQuestion label={t('quiz.solarPanels')} value={data.solar_status} options={[{ value: 'Installed', label: t('quiz.solar.installed') }, { value: 'Planned', label: t('quiz.solar.planned') }, { value: 'Interested', label: t('quiz.solar.interested') }, { value: 'Not interested', label: t('quiz.solar.notInterested') }]} onChange={(val) => onUpdate({ solar_status: val })} testIdPrefix="solar" />

        <RadioQuestion
          label={t('quiz.electricityUsage', 'Jaarlijks elektriciteitsverbruik')}
          value={data.electricity_usage}
          options={[
            { value: '< 2.000 kWh', label: '< 2.000 kWh' },
            { value: '2.000 – 3.000 kWh', label: '2.000 – 3.000 kWh' },
            { value: '3.000 – 4.000 kWh', label: '3.000 – 4.000 kWh' },
            { value: '4.000 – 6.000 kWh', label: '4.000 – 6.000 kWh' },
            { value: '6.000+ kWh', label: '6.000+ kWh' },
            { value: '', label: t('quiz.notSure', 'Weet ik niet') },
          ]}
          onChange={(val) => onUpdate({ electricity_usage: val })}
          testIdPrefix="electricity"
        />

        {/* EV Question 1 */}
        <RadioQuestion
          label="Heeft u een elektrische auto?"
          value={data.electric_vehicle}
          options={[
            { value: 'Nee', label: 'Nee' },
            { value: 'Ja', label: 'Ja' },
            { value: 'Binnen 2 jaar waarschijnlijk', label: 'Binnen 2 jaar waarschijnlijk' },
          ]}
          onChange={(val) => onUpdate({ electric_vehicle: val, ev_home_charging: '', ev_terrain: '' })}
          testIdPrefix="ev"
        />

        {/* EV Question 2 — conditional */}
        {hasEv && (
          <RadioQuestion
            label="Laadt u al thuis of wilt u thuis laden met uw eigen laadpaal?"
            value={data.ev_home_charging}
            options={[
              { value: 'Ik laad al thuis', label: 'Ik laad al thuis' },
              { value: 'Ik wil thuis laden met een eigen laadpaal', label: 'Ik wil thuis laden met een eigen laadpaal' },
              { value: 'Nog niet zeker', label: 'Nog niet zeker' },
            ]}
            onChange={(val) => onUpdate({ ev_home_charging: val })}
            testIdPrefix="ev-charging"
          />
        )}
      </div>
    </div>
  );
}
